import { FC, useCallback, useEffect } from "react";
import { Outlet, useOutletContext } from "react-router";

import { useSiteDetails } from "../app/hooks/useSiteDetails";
import { CompanyAndSiteIds } from "./types";
import { useRequestHandlers } from "../app/hooks/useRequestHandlers";
import { fetchCampaigns } from "../store/features/campaigns/fetch";
import { useAppSelector } from "../store";

export const SiteDetailsOutlet: FC = () => {
  const { siteId, companyId } = useOutletContext<CompanyAndSiteIds>();
  const { siteDetails } = useSiteDetails();
  const { getApi, dispatch } = useRequestHandlers();
  const { campaigns } = useAppSelector((state) => state.campaigns);

  const loadCampaigns = useCallback(async () => {
    const api = await getApi();
    const value = { companyId, siteId };
    const fetchingArgs = { api, value };
    dispatch(fetchCampaigns(fetchingArgs));
  }, [companyId, siteId, getApi, dispatch]);

  useEffect(() => {
    if (!campaigns.length) loadCampaigns();
  }, [loadCampaigns, campaigns.length]);

  return siteDetails ? (
    <Outlet context={{ siteId, companyId, siteDetails }} />
  ) : null;
};
